import Children from 'lib/pages/Why/Children'
export default Children
